export const PAGE_WIDTH_PX = 920;
export const PAGE_HEIGHT_PX = 1331;
export const REPORT_BLOCK_GAP = 4;
export const REPORT_BLOCK_INTERNAL_GAP = 1;
